<template>

	<div class="section-content" style="position: relative;">
		
		<div class="background-carousel"  >
			
			<el-carousel :interval="10000" style="height:100vh;" @change="changeCar" arrow="nerver">
			
				<el-carousel-item  v-for="(slide, index) in slides"  @click.stop="gotoDetail(slide)" :key="slide.carouselId"
					style="height:100vh;width: 100vw;" >
			
					<div  v-if="slide.mediaType == 'mov'"   style="width:100%;overflow: hidden;">
						<video-player class="video-player vjs-custom-skin" ref="videoUrl"
							style="width: 100%;border-radius: 4px;" :playsinline="true" :options="{
									  playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
									  autoplay: true, //如果true,浏览器准备好时开始回放。
									  controls: false, //控制条
									  preload: 'true', //视频预加载
									  muted: true, //默认情况下将会消除任何音频。
									  loop: true, //导致视频一结束就重新开始。
									  language: 'zh-CN',
									  // aspectRatio: '1:1', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（
									  fluid: true,
									  sources: [
									    {
									      type: 'video/mp4',
									      src: slide.carouselUrl
									    }
									  ],
									  poster:slide.poster,
									  notSupportedMessage: '此视频暂无法播放，请稍后再试'
									}"></video-player>
					</div>
					<div v-else-if="slide.mediaType == 'img' " >
						<!-- <div> -->
						<el-image :src="slide.carouselUrl"></el-image>
						<!-- <div class="overlay"></div> -->
					</div>
				</el-carousel-item>
			</el-carousel>
			
			
			
		</div>

		<!-- 内容包装器 -->
		<div  style="pointer-events:auto;position: relative;width: 100vw;
	height: 100vh;
	z-index: 2;
	 
	padding: 0;    width: 40vw;
    margin-left: 60vw;">
			 
			<div class="carousel-controls">
				<div v-for="(slide, index) in slides"  :key="slide.carouselId" class="control-item"
					:class="{ active: currentIndex === index }" @click="setSlide(index)" style="font-weight:600">
					{{ slide.name }}
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import {
		carouselList
	} from '@/api/webstation.js'

	export default {
		name: 'homeOne',
		components: {

		},
		data() {
			return {
				autoPlayInterval: null,
				currentIndex: 0,
				slides: [
				],
			}
		},
		created() {
			// this.startAutoPlay();
			this.getCarouselList()
		},
		methods: {
			changeCar(e){
				// console.log(e);
				this.currentIndex = e
			},
			gotoDetail(data){
				// console.log('data: ',data);
				if(data.isSkip == 0)
				{
					if(data.skipType == 1)
					{
						window.open(data.skipUrl)
					}else{
						
						this.$router.push('/newsInfoDetail?articleId=' + data.articleId)
					}
				}
			},
			jugleMediaType(src) {
				let type = src.split('.').pop()
				if (type == 'mp4' || type == 'mov') {
					return "mov"
				} else {
					return "img"
				}
			},
			getCarouselList() {
				let that = this
				carouselList({}).then(res => {
					if (res.code == 200) {
						that.slides = res.data
						for (var i = 0; i < that.slides.length; i++) {
							var item =  that.slides[i]
							item.mediaType = that.jugleMediaType(item.carouselUrl)
						}
					}

				})
			},

			setSlide(index) {
				this.currentIndex = index;
				this.$emit("clickLBChange",index)
			},
			nextSlide() {
				this.currentIndex = (this.currentIndex + 1) % this.slides.length;
			},
			startAutoPlay() {
				this.autoPlayInterval = setInterval(this.nextSlide, 5000); // 每5秒切换一次
			},
			stopAutoPlay() {
				if (this.autoPlayInterval) {
					clearInterval(this.autoPlayInterval);
				}
			},
		}


	}
</script>
<style scoped>
	@import '../assets/home.css';
	
	/*指示器按钮*/
	/deep/ .el-carousel__button {
	 
	width: 10px;
	  height: 10px;
	  border: none;
	  border-radius: 50%;
	  background-color: rgba(0, 0, 0, 0.2);
	}
	/*指示器激活按钮*/
	/deep/ .is-active .el-carousel__button {
	  background: #fff;
	}
	.dot {
	  display: inline-block;
	  width: 10px;
	  height: 10px;
	  border-radius: 50%;
	  background-color: black;
	  margin: 0 5px;
	}
	 
	.list-enter-active, .list-leave-active {
	  transition: opacity 0.5s;
	}
	.list-enter, .list-leave-to /* .list-leave-active in <2.1.8 */ {
	  opacity: 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/home_one.vue